import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ALERTS, FormBuilder, FormGroup, Validators } from 'src/app/common';
import { ISubscription, ISubscriptionRow } from 'src/app/models';
import { AlertService, BlockUiHandlerService } from 'src/app/services';
import { SubscriptionService } from 'src/app/services/subscription.service';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.css']
})
export class SubscriptionComponent implements OnInit {
  //VARBOX
  modalReference: NgbModalRef;
  EmailForm: FormGroup;
  SubscriptionForm: FormGroup;

  subscriptions: ISubscriptionRow[];
  //emails: string[];

  constructor(
    private alertService: AlertService,
    private formBuilder: FormBuilder,
    private subscriptionService: SubscriptionService,
    private blockUiService: BlockUiHandlerService,
    private modalService: NgbModal) { }

  ngOnInit(): void {
    this.InitVariables();
    this.LoadData();
  }

  InitVariables(): void {
    this.ResetEmailForm();
    this.ResetSubscriptionForm();
  }

  LoadData(): void {
    this.subscriptions = [];
    this.GetAllSubscriptions();
  }

  RaiseUserModal(content, isUpdating: boolean = false): void {
    if (!isUpdating) this.ResetSubscriptionForm();
    this.modalReference = this.modalService.open(content, 
      {
        centered: true,
        backdrop: 'static'
      });
  }

  CloseModal(): void {
    this.modalReference.close();
  }

  ResetEmailForm(): void {
    this.EmailForm = this.formBuilder.group({
      Id: [-1],
      Email: ['', [Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]]
    });
  }

  ResetSubscriptionForm(): void {
    this.SubscriptionForm = this.formBuilder.group({
      Id: [-1],
      Email: ['', [Validators.minLength(2), Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$')]]
    });
  }

  AddEmail(event: any): void {
    if (event.key == 'Enter' && this.EmailForm.controls['Email'].value) {
      if (!this.EmailForm.controls['Email'].invalid) {
        let Subscription = this.EmailForm.value as ISubscription;
        let SubscriptionRow = {Subscription: Subscription, OrderConfig: null, RequestConfig: null}
        this.subscriptions.push(SubscriptionRow);
        this.ResetEmailForm();
      }
    }
  }

  GetAllSubscriptions(){
    this.blockUiService.Start(1, `Cargando subscripciones...`);
    this.subscriptionService.GetAllSubscriptions().subscribe(next => {
      this.blockUiService.Stop();
      if (next.Result) {
        next.Subscriptions.forEach(sub => {
          let SubscriptionRow = {Subscription: sub, OrderConfig: null, RequestConfig: null}
          this.subscriptions.push(SubscriptionRow)
        })
      }
    }, error => {
      this.blockUiService.Stop();
      this.alertService.ShowSmallCornerAlert(`Error: ${error}`, ALERTS.warning);
    });;
  }

  GetSubscription(Id: number, Content: any): void {
    this.RaiseUserModal(Content, true);
  }

}
